var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Datatable',{attrs:{"entity":"customer","parameters":{branch: _vm.$route.query.branch},"onRowClick":_vm.displayCustomer,"rowActions":[{text: 'datatable.display', method: _vm.displayCustomer}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }